import React from 'react';
import { Home, Droplets, Maximize, DoorOpen, Bath, Square, Layout, Grid } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Home Window Glass Repair',
    copy: 'Broken, cracked or shattered window glass repaired or replaced for single-pane, double-hung, casement, bay, bathroom and other home windows.',
    icon: <Home className="w-8 h-8 text-brandBlue-600" data-id="element-177" />
  }, {
    title: 'Foggy Double-Pane & Seal Repair',
    copy: 'Fog or condensation between panes often means an insulated glass seal has failed. Kosin’s Glass can inspect the unit and recommend repair or glass replacement.',
    icon: <Droplets className="w-8 h-8 text-brandBlue-600" data-id="element-178" />
  }, {
    title: 'Window Glass Replacement Only',
    copy: 'When your window frames are still in good condition, replacing the glass only can be a smart alternative to full replacement windows.',
    icon: <Maximize className="w-8 h-8 text-brandBlue-600" data-id="element-179" />
  }, {
    title: 'Door Glass & Glass Inserts',
    copy: 'Replacement glass for entry doors, patio doors, storm doors, interior door glass, decorative inserts and other residential door glass.',
    icon: <DoorOpen className="w-8 h-8 text-brandBlue-600" data-id="element-180" />
  }, {
    title: 'Custom Glass Shower Doors',
    copy: 'Frameless, semi-frameless, sliding, Euro-style shower doors and custom shower enclosures designed, measured and installed for your bathroom.',
    icon: <Bath className="w-8 h-8 text-brandBlue-600" data-id="element-181" />
  }, {
    title: 'Custom Mirrors',
    copy: 'Bathroom mirrors, vanity mirrors, wall mirrors, home gym mirrors, beveled mirrors, tinted mirrors, etched mirrors and custom-shaped mirrors.',
    icon: <Square className="w-8 h-8 text-brandBlue-600" data-id="element-182" />
  }, {
    title: 'Table Tops, Shelves & Decorative Glass',
    copy: 'Custom glass table tops, shelves, cabinet glass, patterned glass, etched glass, interior glass and specialty glass for home projects.',
    icon: <Layout className="w-8 h-8 text-brandBlue-600" data-id="element-183" />
  }, {
    title: 'Screens & Glass Deck Railings',
    copy: 'Window screen and door screen repair or replacement, plus custom glass panels for modern deck railings and outdoor views.',
    icon: <Grid className="w-8 h-8 text-brandBlue-600" data-id="element-184" />
  }];
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-slate-50" data-id="element-185">
      <div className="max-w-7xl mx-auto" data-id="element-186">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-187">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 mb-6 tracking-tight" data-id="element-188">
            Residential Glass Services for Every Room in Your Home
          </h2>
          <p className="text-lg text-slate-600" data-id="element-189">
            From broken home windows to custom shower glass, mirrors and table
            tops, Kosin’s Glass repairs, replaces, designs and fabricates
            residential glass for homeowners across Southeast Michigan.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-190">
          {services.map((service, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-soft border border-slate-100 hover:shadow-card transition-shadow" data-id="element-191">
              <div className="w-14 h-14 rounded-xl bg-glassBlue-50 flex items-center justify-center mb-6" data-id="element-192">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-193">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-194">{service.copy}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-195">
          <a href="#estimate-form" className="inline-flex items-center justify-center bg-brandBlue-600 hover:bg-brandBlue-700 text-white font-bold text-lg py-4 px-8 rounded-xl transition-colors shadow-md" data-id="element-196">
            Request a Free Residential Glass Estimate
          </a>
        </div>
      </div>
    </section>;
}